import Section from "./Section";
import {Typography} from "@mui/material";

export default function Intro() {
  return (
    <Section>
      <Typography fontWeight={900} color="primary" textTransform="uppercase" textAlign="center" sx={{
        fontSize: {xs: '3rem', md: '3.75rem'},
      }}>
        Calling all Groms
      </Typography>
      <Typography variant="body1" sx={{
        fontSize: '1.5rem',
        textAlign: 'center',
      }}>
        For
      <Typography variant="h5" fontFamily="Noot" textTransform="uppercase" whiteSpace="nowrap" color="primary" px={1} display="inline">
        ages 12 and under
      </Typography>,
        ride the C4C trails to win a kids ice cream:
      </Typography>
      <Typography variant="body1" sx={{
        fontSize: '1.5rem',
      }}>
        <ul>
          <li>Join our summer event, designed to get kids riding. Getting started is easy.</li>
          <li>Head out with a parent (or solo if you have a phone) and ride the trails below. We’ve mapped it.</li>
          <li>Along the route, you’ll find different colour cones with a QR code on them. Scan them to build up a stamp card. Get 7 out of the 10 stamps and you've earned yourself kids ice cream from the Old School Ice Cream Bus.</li>
          <li><Typography variant="h5" fontFamily="Noot" textTransform="uppercase" whiteSpace="nowrap" color="primary" px={1} display="inline">
            Note:
          </Typography>this event is open to kids only. Adults - head along for the ride, then purchase your ice cream when your kiddo claims their free one! Don’t forgot to tip your server at the bus.</li>

        </ul>
      </Typography>
    </Section>
  )
}